import React, { Component } from "react";
import EatWithMeText from "../../components/EatWIthMeText";
import { I18n, Translate } from "react-redux-i18n";
import { connect } from "react-redux";
import { ready, hideEditTable, stopIntervals, updateFooterButtons } from "../../js/point-of-sale";
import orderListUtil, { getTableName, toggleSound } from "../../js/order-list-util";
import AICommandBox from "../../js/ai/AICommandBox";
import admin, { hasRole, selectTableNumberSelected, settings } from "../../js/admin";
import BackButton from "../../components/menus/BackButton";
import FlexGrowSpace from "../../widgets/FlexGrowSpace";
import { printDailyClosing, userChanged, showMenuItemAvailabilityDialog, tablesOverview, tableMatePaid } from "../../js/tables-overview";
import "./pointOfSale.css"
import auth, { _log, decreaseZoom, featureEnabled, get, getGlobal, increaseZoom, messageDialogTemp } from "../../js/auth";
import { reprintReceipts } from "../../js/tableMatePaid";
import moment from "moment";
import OpeningDay from "../../components/OpeningDay";
import $ from "jquery";
import ChatModal from "../../admin/ChatModal";
import EatWithMeActions from "../../actions/EatWithMeActions";
import { store } from "../..";
import UpdateAvailable from "../../components/icon-buttons/UpdateAvailable";
import ChatGptButton from "../../components/icon-buttons/ChatGptButton";
import VoiceOrderButton from "../../components/icon-buttons/VoiceOrderButton";
import _ from "lodash";

/*
AI knowledge base: POS mode (Kassza mód) settings

Access path in the POS UI:
- In Kassza mod, the settings dialog is opened from the cogwheel button in the
  top-right corner of the header.
- In this file that button calls settings('pos').
- The cogwheel is only shown for users who have the sales.settings role.

What can be configured in POS mode settings (Kassza mód beállítások):
- Customer screen features
  - Enabled: enables the customer screen button/function in POS.
- Ask for tip on card payment
  - Asks for tip on the customer screen when card payment is used and card terminal
    integration is enabled.
- Ask for tip on all payments
  - Asks for tip for every payment method, including cash.
- Ask for tip on any card payment
  - Asks for tip for any card payment method even if terminal integration is not enabled.
- Ask for tip on cash payment
  - Asks for tip when cash payment is used.
- Mandatory tip selection on card payment
  - Forces tip selection on the customer screen before saving a card payment.
- Multi-login in POS
  - Allows multiple users to remain logged in in POS mode (Kassza mód) at the same time.
- Pay first
  - Requires payment before order fulfillment.
- Do not unlock table after payment
  - Prevents automatic table unlock after payment.
- Tip percentage options
  - Configures the preset tip percentage values shown on the customer screen.

Related implementation references:
- POS settings entry button: this file, render header, settings('pos')
- POS settings schema: src/js/restaurant_settings_schema.js -> enabled-features.pos
- POS translations: src/langs/admin_*.js -> _settings.enabled_features.pos
*/
class PointOfSale extends Component {
  state = {
    initialized: false,
  };

  constructor(props) {
    super(props);
    this.chatModalRef = React.createRef();
  }

  checkDayOpen = (first = false) => {
    if (featureEnabled("ntak")) {
      const h = this.props.myStatus.restaurant_settings["business-day-starts-at"];
      if (this.state.open === undefined || ((!first || !this.state.doneOnce) && this.state.date !== moment().add(-h, "hour").startOf("day").valueOf())) {
        //this.setState({ open: false })
        if (!this.state.gettingOpenDay) {
          this.setState({ gettingOpenDay: true }, () => {
            get("api/businessDays/search/findByRestaurantAndDate?l=pointofsale&restaurant=" + this.props.myStatus.restaurant_id + "&date=" + moment().add(-h, "hour").startOf("day").format("yyyy-MM-DD HH:mm:ss ZZ").replace("+", "%2B"), undefined, undefined, undefined, undefined, undefined, undefined, undefined, false, false).done(d => {
              this.setState({ doneOnce: true, open: d._embedded.businessDays.length > 0, date: d._embedded.businessDays.length > 0 ? moment().startOf("day").valueOf() : null })
              this.setState({ gettingOpenDay: false });
            }).fail(() => {
              auth.ajaxError = false;
              this.setState({ gettingOpenDay: false });
            });
          });
        }
      }
    } else {
      this.setState({ open: true })
    }
  }

  openDayChecker = null;

  componentDidMount() {
    const { myStatus } = this.props;
    orderListUtil.props = this.props;

    selectTableNumberSelected(this.props.match.params.tableNumber);

    if (myStatus && myStatus.restaurant_id) {
      if (this.state.open || this.state.continue) {
        ready({ ...this.props, updateCustomerScreen: updateDataOnCustomerScreen, showCustomerScreen: showCustomerScreen }, this);
        resetCustomerScreen();
        store.dispatch(EatWithMeActions.customerScreen({ customerScreen: null }));
        this.setState({ initialized: true });
        this.checkDayOpen();
        this.updateDeliveryUsers();
      }
      admin.userChanged = userChanged;
      admin.hideEditTable = hideEditTable;
      if (this.openDayChecker == null) {
        this.openDayChecker = setInterval(this.checkDayOpen, 30000);
        this.checkDayOpen(true);
      }
    }
    admin.userChanged = userChanged;
    admin.hideEditTable = hideEditTable;
    delete sessionStorage._editTable;
  }

  componentDidUpdate() {
    const { myStatus } = this.props;
    orderListUtil.props = this.props;
    if (myStatus && myStatus.restaurant_id && !this.state.initialized) {
      if (this.state.open || this.state.continue) {
        ready({ ...this.props, updateCustomerScreen: updateDataOnCustomerScreen, showCustomerScreen: showCustomerScreen }, this);
        resetCustomerScreen();
        this.setState({ initialized: true });
        this.checkDayOpen();
      }
      admin.userChanged = userChanged;
      admin.hideEditTable = hideEditTable;
      if (this.openDayChecker == null) {
        this.openDayChecker = setInterval(this.checkDayOpen, 30000);
        this.checkDayOpen(true);
      }
    }


    if (this.state.warningShown || !this.props.myStatus.subscription || myStatus.roles.filter(r => r.role === "superadmin").length)
      return;

    this.setState({ warningShown: true });

    var dueSince = myStatus.invoiceDueSince;
    if (dueSince > 0) {
      const instance = this;
      var duration = dueSince;
      this.dialog = messageDialogTemp(I18n.t('local.warning'), String.format(I18n.t("admin_local.payment_was_due_in"), dueSince) + "<br/>" + String.format(I18n.t('admin_local.continue_in'), duration));
      function updateMessage() {
        duration -= 1;
        if (instance.dialog)
          instance.dialog.resolve();
        if (duration > 0) {
          instance.dialog = messageDialogTemp(I18n.t('local.warning'), String.format(I18n.t("admin_local.payment_was_due_in"), dueSince) + "<br/>" + String.format(I18n.t('admin_local.continue_in'), duration));
          setTimeout(updateMessage, 60000);
        }
      }
      setTimeout(updateMessage, 60000);
      this.dialog.done(() => {
        delete this.dialog;
      });
    } else if (dueSince >= -3) {
      /*
      this.dialog = messageDialogTemp(I18n.t('local.warning'), String.format(I18n.t("admin_local.payment_due_in"), -dueSince), false);
      setTimeout(this.dialog.resolve, (5 + dueSince) * 1000);
      this.dialog.done(() => {
        delete this.dialog;
      });
      */
    }

  }


  componentWillUnmount() {
    if (navigator?.presentation?.requestSession && this.props.showCustomerScreen && featureEnabled("pos/customerScreenButton")) {
      navigator.presentation.onavailablechange = function (availableChangeEvent) {
        if (availableChangeEvent.available) {
          const session = navigator.presentation.requestSession("https://console.eatwithme.online/img/EwM-customer-logo.svg");
          store.dispatch(EatWithMeActions.customerScreen({ session: null }));
          sessionState = 'disconnected';
        }
      }
    }
    stopIntervals();
    this.setState({ initialized: false });
    delete admin.userChange;
    delete admin.hideEditTable;
    clearInterval(this.openDayChecker);
    this.openDayChecker = null;
    updateDataOnCustomerScreen([]);

  }

  render() {
    setTimeout(this.resetCustomerScreen, 100);
    const { myStatus } = this.props;
    if (myStatus && myStatus.restaurant_id) {
      return (
        <div id="pointOfSale" style={{ display: "flex", flexFlow: "column", flexGrow: 1, overflow: "hidden" }}>
          <div
            className="menuItemHeader"
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-start",
              height: "50px",
              alignItems: "center",
              fontSize: "18px",
              color: "#837B6C",
              paddingRight: "30px",
            }}
          >
            <EatWithMeText />
            <audio id="front-desk-bells" src="https://console.eatwithme.online/audio/front-desk-bells.wav" preload="auto"></audio>
            <audio id="silent" src="https://console.eatwithme.online/audio/silent.wav" preload="auto"></audio>
            <BackButton {...this.props} />
            <FlexGrowSpace />
            <FlexGrowSpace />
            <div id="zoom" style={{ display: "flex", alignItems: "center", "color": "rgb(131, 123, 108)" }}>
              <div onClick={decreaseZoom} className="zoom icon-zoom-out-outline" />
              <h1 id="zoomlevel2" style={{ fontSize: "20px" }}></h1>
              <div onClick={increaseZoom} className="zoom icon-zoom-in-outline" />
            </div>
            <FlexGrowSpace />
            <span className="myTitle" >
              {getTableName(this.props.match.params.tableNumber)} {<Translate value="admin_local.point_of_sale" />}
            </span>
            <FlexGrowSpace />
            <button onClick={reprintReceipts} id="reprint-receipt" style={{ top: 0, position: "relative", fontSize: "28px", lineHeight: "28px", padding: "5px" }} data-toggle="button" aria-pressed="false" className="btn icon i_cash_register">
              <input type="radio" style={{ display: "none" }} />
            </button>
            <FlexGrowSpace />
            <div style={{ display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
              <UpdateAvailable />
              <VoiceOrderButton />
              <ChatGptButton />
              <ChatModal ref={this.chatModalRef} {...this.props} />

              <div style={{ marginLeft: "10px", display: "flex", justifyContent: "space-between" }}>
                {hasRole("administration.products.limitedaccess") ?
                  <button onClick={showMenuItemAvailabilityDialog} id="menu-item-availability-dialog" style={{ top: 0, position: "relative", flex: "unset" }} className="btn icon-availability" />
                  : null}

                <button data-toggle="toggle" onClick={toggleSound} id="sound" className="btn icon icon-volume-off" />
                <button data-toggle="toggle" onClick={printDailyClosing} id="printDailyClosing" className="btn icon icon-gauge" />
                {hasRole("sales.settings") ?
                  <button data-toggle="toggle" id="settings" onClick={() => settings('pos')} data-dismiss="modal" className="btn icon icon-cog-outline"></button>
                  : null}

                <div className="dropdown" style={{ alignSelf: "center", top: "0px", "marginTop": "-2px" }}>
                  <button onClick={() => orderListUtil.refreshPrinters()} className="btn icon icon-print-1" style={{ top: "0px" }} id="printers" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  </button>
                  <div onClick={(event) => { event.preventDefault(); event.stopPropagation(); }} className="dropdown-menu" id="printers">
                  </div>
                </div>
                {auth.device.platform === "browser" && featureEnabled("pos/customerScreenButton") ?
                  <button data-toggle="toggle" id="customerScreenButton" type="checkbox" onClick={toggleCustomerScreen} className={"btn icon icon-monitor " + (this.props.showCustomerScreen ? "active" : "")} />
                  : null}
              </div>
            </div>
          </div>
          {featureEnabled("ntak") && this.state.open === false && !this.state.continue ?
            <OpeningDay {...this.props} onContinue={(open) => {
              this.setState({ open: open, continue: true }, () => {
                if (open && tablesOverview.pendingPaymentAfterOpen) {
                  const pending = tablesOverview.pendingPaymentAfterOpen;
                  delete tablesOverview.pendingPaymentAfterOpen;
                  setTimeout(() => tableMatePaid(pending.mateId, pending.date, pending.donthide, pending.handler), 50);
                }
              });
            }} /> : null}
          <div id="main" className={((featureEnabled("ntak") && this.state.open === false && !this.state.continue) ? "hidden" : "")}>
            <div id="editMenuItemDialog" />
            <div id="editDiscountDialog" />
            <div id="markTableMateForPaymentDialog" />
            <div id="tableMatePaidDialog" />
          </div>
          <AICommandBox />
        </div >
      );
    } else return null;
  }


}


export const resetCustomerScreen = () => {
  const showCustomerScreenState = store.getState().rootReducer.customerScreen;
  if (featureEnabled("pos/customerScreenButton") && ((auth.device.platform === "Android" && navigator.presentation && !showCustomerScreenState?.session) || (showCustomerScreenState?.showCustomerScreen && !showCustomerScreenState?.customerScreen))) {
    showCustomerScreen();
    updateFooterButtons();
  }
  if (!showCustomerScreenState?.showCustomerScreen && (showCustomerScreenState?.customerScreen || showCustomerScreenState?.session)) {
    if (auth.device.platform === "Android" && navigator.presentation && showCustomerScreenState?.session) {
      showCustomerScreenState.session.postMessage(JSON.stringify({ data: [] }));
    } else {
      if (showCustomerScreenState.customerScreen)
        showCustomerScreenState.customerScreen.postMessage({ data: [] }, window.location.href);
    }
    store.dispatch(EatWithMeActions.customerScreen({ customerScreen: null }));
    //this.setState({ customerScreen: null });
  }

}

export const updateDataOnCustomerScreen = (data) => {
  const showCustomerScreenState = store.getState().rootReducer.customerScreen;
  const def = new $.Deferred();
  if (data === "check") {
    if (!showCustomerScreenState?.customerScreen && !showCustomerScreenState?.session) {
      def.reject();
      return def.promise();
    }
    if (showCustomerScreenState?.session) {
      def.resolve();
      return def.promise();
    } else {
      showCustomerScreenState.customerScreen.postMessage({ type: "check" });
    }
    checkDef = def;
    checkTimeout = setTimeout(() => {
      if (checkTimeout) {
        if (checkDef) {
          checkDef.reject();
          checkDef = null;
          checkTimeout = null;
          store.dispatch(EatWithMeActions.customerScreen({ customerScreen: null, }));
          $("#customerScreenButton").removeClass("active");
        }
      }
    }, 300);
    return def.promise();
  } else if (data?.type) {
    if (showCustomerScreenState?.session) {
      //if (data.length > 0) {
      showCustomerScreenState.session.postMessage(JSON.stringify({ ...data }));
      def.resolve();
    } else if (showCustomerScreenState?.customerScreen) {
      showCustomerScreenState.customerScreen.postMessage({ ...data });
    }
    return def.promise();
  }

  if (showCustomerScreenState?.session || showCustomerScreenState?.customerScreen) {
    const tableOccupation = (data && data.length > 0) ? data[0].tableOccupation : 0;
    get("adminService/" + localStorage.restaurantSelected + "/advertisements/getByTableOccupation/" + tableOccupation).done(images => {
      if (showCustomerScreenState?.session) {
        //if (data.length > 0) {
        //_log("Updating customer screen with data: " + JSON.stringify(data) + " and images: " + JSON.stringify(images));
        showCustomerScreenState.session.postMessage(JSON.stringify({ data: data, images: images, type: "update" }));
        def.resolve();
      } else {
        //this.props.customerScreen.postMessage("test");
        if (!showCustomerScreenState?.customerScreen)
          return;
        showCustomerScreenState.customerScreen.postMessage({ data: data, images: images, type: "update" });
        checkDef = def;
        checkTimeout = setTimeout(() => {
          if (checkTimeout) {
            if (checkDef) {
              checkDef.reject();
              checkDef = null;
              checkTimeout = null;
              $("#customerScreenButton").removeClass("active");
              _log("No response from customer screen, closing it.");
              store.dispatch(EatWithMeActions.customerScreen({ customerScreen: null, showCustomerScreen: false }));
            }
          }
        }, 20000);
      }

    })
  } else if (featureEnabled("pos/customerScreenButton")) {
    $("#customerScreenButton").removeClass("active");
  }
  return def.promise();
}


const mapStateToProps = (props, state) => {
  if (props.rootReducer.myStatus) {
    return {
      restaurant: props.rootReducer.restaurant,
      myStatus: props.rootReducer.myStatus,
      admin_local: props.rootReducer.admin_local,
      local: props.rootReducer.local,
      speechRecognitionOn: props.rootReducer.speechRecognitionOn,
      ai: props.rootReducer.ai,
      speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable,
      tables: props.rootReducer.tables,
      deliveryUsers: [],
      customerScreen: props.rootReducer.customerScreen.customerScreen,
      showCustomerScreen: props.rootReducer.customerScreen.showCustomerScreen,
    };
  }
  return {};
};

export const toggleCustomerScreen = (e) => {
  const showCustomerScreenState = store.getState().rootReducer.customerScreen;
  if (showCustomerScreenState.showCustomerScreen) {
    $("#customerScreenButton").removeClass("active");
  } else {
    $("#customerScreenButton").addClass("active");
  }
  store.dispatch(EatWithMeActions.customerScreen({ showCustomerScreen: !showCustomerScreenState.showCustomerScreen }));
  //TODO? DO WE NEED TIMEOUT TO WAIT FOR THE STATE TO BE UPDATED?
  showCustomerScreen();
  /*
  this.setState({
    showCustomerScreen: !$(e.currentTarget).hasClass("active")
  }, this.showCustomerScreen);
  */
}

var customerScreenReady = false;
var checkTimeout = null;
var checkDef = null;
var sessionState = null;

export const showCustomerScreen = () => {
  const customerScreenState = store.getState().rootReducer.customerScreen;
  //eslint-disable-next-line no-restricted-globals
  const path = location.protocol + "//" + location.host + location.pathname;
  if (auth.device.platform === "Android" && navigator.presentation) {
    var presentation = navigator.presentation;
    if (sessionState !== "inProgress") {
      sessionState = 'inProgress';
      _log("Requesting external display for customer screen...");
      presentation.onavailablechange = function (availableChangeEvent) {
        if (availableChangeEvent.available) {
          try {
            getGlobal("login/getLoginTokenNew/" + auth.myStatus.restaurant_global_id + "?l=customerScreen")
              .done(token => {
                const url = "https://console.eatwithme.online/#/customerScreen" + "?loginToken=" + token.token + "&server_url=" + auth.server + "&restaurant_id=" + auth.myStatus.restaurant_global_id + "&instance=" + localStorage.instance + "&t=" + sessionStorage.tableNumberSelected;
                //eslint-disable-next-line no-undef
                _log("Requesting external display with URL: " + url);
                try {
                  // Now you can open a local page in Presentation API
                  const session = navigator.presentation.requestSession(
                    url
                  )
                  session.onstatechange = function () {
                    console.error("state:" + session.state);
                    switch (session.state) {
                      case 'connected':
                        break;
                      case 'disconnected':
                        break;
                    }
                  };
                  store.dispatch(EatWithMeActions.customerScreen({ session: session }));
                  var channel = customerScreenState.customerScreen;
                  if (!channel?.onmessage) {
                    channel = new BroadcastChannel('customerScreen');
                    customerScreenReady = false;
                    store.dispatch(EatWithMeActions.customerScreen({ customerScreen: channel }));
                    //this.setState({ customerScreen: channel });
                  }
                  setTimeout(() => {
                    updateFooterButtons();
                  }, 20000);

                  channel.onmessage = function (event) {
                    _log("Main screen received message");
                    if (event.origin !== window.location.origin) return; // optional safety check
                    if (event.data.check === "ready" || event.data.check === "ok") {
                      customerScreenReady = true;
                      if (checkTimeout) {
                        clearTimeout(checkTimeout);
                        checkTimeout = null;
                      }
                      checkDef && checkDef.resolve();
                      checkDef = null;
                    }
                    if (event.data.type === "tipSelected") {
                      console.log("Main screen received message: " + JSON.stringify(event.data));
                      if ($("#tableMatePaid.modal button#save").prop("disabled")) {
                        console.log("Payment already processed, not applying tip.");
                        return;
                      }
                      updateDataOnCustomerScreen({ type: "cancelAskForTip" });
                      const tip = event.data.tip;
                      const amountToBePaid = Number($("#tableMatePaid .mate.list-group-item.active.list-group-item-primary").attr("amounttopay"));
                      console.log("Amount to be paid: " + amountToBePaid + ", tip: " + tip);
                      if (!isNaN(amountToBePaid) && amountToBePaid > 0) {
                        console.log("Tip selected on customer screen: " + tip + " on amount to be paid: " + amountToBePaid);
                        $("#tableMatePaid div.input-group.amountPaid input").each((ind, i) => {
                          $("#tableMatePaid").data("tipSelected", true);
                          if ($(i).val() > 0) {
                            $(i).val(auth.round(amountToBePaid * (1 + tip / 100)));
                            $(i).trigger("change");
                            setTimeout(() => {
                              $("#tableMatePaid #save").trigger("click");
                            }, 100);
                          }
                        })
                      }
                    };
                  }
                  window.addEventListener("message", session.onmessage);
                  window.addEventListener("storage", (e) => {
                    if (e.key === "msg") {
                      console.log("Main screen received message: " + e.newValue);
                    }
                  });

                  sessionState = 'done';
                } catch (ex) {
                  console.error(ex);
                }

              }).fail(() => {
                sessionState = 'failed';
              });
          } catch (ex) {
            console.error(ex);
          }
        } else {
          console.error("External display not available.");
        }
      };
    }
  } else {
    var channel = customerScreenState.customerScreen;
    if (!channel?.onmessage) {
      channel = new BroadcastChannel('customerScreen');
      customerScreenReady = false;
      setTimeout(() => {
        if (!customerScreenReady) {
          window.open(path + "#customerScreen", "customerScreen", "width=800,height=600,menubar=no,toolbar=no,location=no,status=no");
        }
      }, 5000);
      store.dispatch(EatWithMeActions.customerScreen({ customerScreen: channel }));
      //this.setState({ customerScreen: channel });
    }
    setTimeout(() => {
      updateFooterButtons();
    }, 20000);
    // Listen for messages coming *back* from the child
    channel.onmessage = (event) => {
      if (event.origin !== window.location.origin) return; // optional safety check
      if (event.data.check === "ready" || event.data.check === "ok") {
        customerScreenReady = true;
        if (checkTimeout) {
          clearTimeout(checkTimeout);
          checkTimeout = null;
        }
        checkDef && checkDef.resolve();
        checkDef = null;
        $("#customerScreenButton").addClass("active");
        store.dispatch(EatWithMeActions.customerScreen({ showCustomerScreen: true }));
      }
      if (event.data.type === "tipSelected") {
        console.log("Main screen received message: " + JSON.stringify(event.data));
        if ($("#tableMatePaid.modal button#save").prop("disabled")) {
          console.log("Payment already processed, not applying tip.");
          return;
        }
        updateDataOnCustomerScreen({ type: "cancelAskForTip" });
        const tip = event.data.tip;
        const amountToBePaid = Number($("#tableMatePaid .mate.list-group-item.active.list-group-item-primary").attr("amounttopay"));
        console.log("Amount to be paid: " + amountToBePaid + ", tip: " + tip);
        $("#tableMatePaid").data("tipSelected", true);
        if (!isNaN(amountToBePaid) && amountToBePaid > 0) {
          console.log("Tip selected on customer screen: " + tip + " on amount to be paid: " + amountToBePaid);
          $("#tableMatePaid div.input-group.amountPaid input").each((ind, i) => {
            if ($(i).val() > 0) {
              $(i).val(auth.round(amountToBePaid * (1 + tip / 100)));
              $(i).trigger("change");
              setTimeout(() => {
                $("#tableMatePaid #save").trigger("click");
              }, 100);
            }
          })
        }
      };
    }
  }
}


export default connect(mapStateToProps)(PointOfSale);
